<template>
  <div v-if="loaded" class="row">
  <!-- Réorganise ton formulaire ici -->
    <mh-input mhClass="col-6" label="Émis par" field="emittedBy" :table="document"></mh-input>
    <mh-input mhClass="col-6" label="Portée" field="isPrivate" :table="document"></mh-input>
    <mh-input mhClass="col-12" lable="Inititulé" field="intitule" :table="document"></mh-input>
    <mh-input mhClass="col-12" label="Note" field="note" :table="document"></mh-input>
    <b-col class="text-right mt-3">
      <b-button @click="$emit('close')">Annuler</b-button>
      <b-button @click="save" class="ml-3">Enregistrer</b-button>
    </b-col>
  </div>
</template>

<script>
import documents from "@/services/documents";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "DocumentNote",
  components: {
    MhInput,
  },
  props: {
    object: [String],
    document_id: [Number, String],
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      document: {},
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      documents
        .get_single(this.$props.object, this.$props.document_id)
        .then((response) => {
          this.document = response.data;
          this.loaded = true;
          
        });
    },
    
    save() {
      documents.update({
        object: this.object,
        document_id: this.document_id,
        document: this.document
      }).then(response => {
        if (response.data.success) {
          this.$bvToast.toast("Document mis à jour", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          for (let el in this.document) {
            if (this.document[el]) {
              this.document[el].error = false;
            }
          }
          this.$emit('change');
          this.$emit('close');
        } else if (response.data.fail) {
          for (let el in this.document) {
            if (this.document[el]) {
              this.document[el].error = false;
            }
          }
          response.data.fail.forEach((element) => {
            this.document[element.field].error = element.errors.join(" ; ");
          });
        } else if (response.data.error) {
          this.$bvToast.toast("Erreur : " + response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>